import { component } from 'flightjs';
import * as analytics from './login-signup-analytics';

export function trackLoginSuccess(memberId) {
    analytics.trackEvent('user-login-success', memberId);
}

export function trackLoginFailure(validationError) {
    analytics.trackEvent('user-login-fail', null, validationError);
}

function LoginWithPasswordButton() {
    this._click = function () {
        const connect = this.$node.data('loginConnect') || 'none';
        const inIframe = this.$node.data('loginSubmitIframe');
        if (connect !== 'none') {
            analytics.trackEvent('user-connect-submit');
        } else if (inIframe) {
            analytics.trackButtonClick();
        } else {
            analytics.flow.set(analytics.FLOW.LOGIN);
            analytics.method.set(analytics.METHOD.PASSWORD);
            analytics.trackEvent('user-login-submit');
        }
    };
    this.after('initialize', function () {
        this.on('click', this._click.bind(this));
    });
}

function TrackLoginSuccess() {
    this.after('initialize', function () {
        analytics.trackEvent('user-login-success', this.$node.data('memberId'));
    });
}

function TrackConnectSuccess() {
    this.after('initialize', function () {
        analytics.trackEvent(
            'user-connect-success',
            this.$node.data('memberId')
        );
    });
}

function TrackLoginFailure() {
    this.after('initialize', function () {
        analytics.trackEvent(
            'user-login-fail',
            null,
            this.$node.data('errorCode')
        );
    });
}

function TrackConnectFailure() {
    this.after('initialize', function () {
        analytics.trackEvent(
            'user-connect-fail',
            null,
            this.$node.data('errorCode')
        );
    });
}

export const LoginWithPasswordButtonComponent = component(
    LoginWithPasswordButton
);
export const TrackLoginSuccessComponent = component(TrackLoginSuccess);
export const TrackConnectSuccessComponent = component(TrackConnectSuccess);
export const TrackLoginFailureComponent = component(TrackLoginFailure);
export const TrackConnectFailureComponent = component(TrackConnectFailure);
